<template>
  <div class="mountain-section trails" id="all-area-trails">
    <div class="mountain-area" v-for="(area, index) in trailMountainAreas" :key="`area-${index}`">
      <h1 class="area-name ttu" v-if="showAreaName(area)">{{ $t(area.Name) }}</h1>
      <div class="trail-counts">
        <strong>{{ area.OpenTrailsCount }}</strong>/{{ area.TotalTrailsCount }}
        {{ $t('OPEN') }}
      </div>

      <transition-group class="flex-grid flex-grid--halfs" name="fade" mode="out-in" tag="div">
        <Trail
          v-for="(trail, index) in filterTrailsForTouring(area.Trails)"
          :index="index"
          :trail="trail"
          :key="`trail-${trail.Name}-${index}`"
        ></Trail>
      </transition-group>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Trail from '@/components/MountainAreas/Trail.vue';

export default {
  name: 'Trails',
  components: {
    Trail,
  },
  computed: {
    trailMountainAreas() {
      if (this.mtnAreaNavSections.indexOf('trails') < 0) {
        return this.mountainAreas;
      }

      return this.currentActiveMountainArea
        ? [this.currentActiveMountainArea]
        : this.mountainAreas;
    },
    // This could be Yes / No if NO separate Uphill Tab.
    // Otherwise its just 'No'
    touringVals() {
      if (this.mtnAreaNavSections.indexOf('uphill') >= 0) {
        return ['No'];
      }
      return ['Yes', 'No'];
    },
    ...mapState(['mountainAreas', 'mtnAreaNavSections']),
    ...mapGetters([
      'currentActiveMountainArea',
      'openStatuses',
    ]),
  },
  methods: {
    showAreaName(area) {
      return area.Name !== '--';
    },
    filterTrailsForTouring(trails) {
      // Don't filter out Touring trails if its not enabled
      if (this.mtnAreaNavSections.indexOf('uphill') < 0) { return trails; }

      return trails.filter(trail => this.touringVals.indexOf(trail.Touring) >= 0);
    },
  },
};
</script>

<style lang="scss" scoped>
#dashboard {
  .trails {
    .mountain-area {
      margin-bottom: 30px;
      .trail:last-child {
        margin-right: 1.5%; // reset spacing to not push over
      }
      h1.area-name  {
        color: $medium-gray;
        display: inline-block;
        font-family: $headline-font-regular;
        font-size: 26px;
        font-weight: 500;
        letter-spacing: 0.5px;
        line-height: 1.2;
        margin: 0 10px 20px 0;
        max-width: 55%;
        @media (min-width: $tablet) {
          max-width: auto;
        }
        @media (min-width: $small-phone) {
          max-width: 65%;
        }
      }
      .trail-counts {
        color: $dark-gray;
        display: inline-block;
        float: right;
        font-family: $base-font-regular;
        font-size: 20px;
        line-height: 1.2;
        strong {
          font-family: $base-font-bold;
          font-weight: $headline-font-weight;
        }
        @media (min-width: $tablet) {
          float: none;
        }
      }
    }
    @media (max-width: $tablet) {
      .flex-grid {
        display: block;
        width: 100%;
      }
    }
  }
}
</style>

<i18n locale="fr-ca">
{
  "All": "Tous",
  "South Side": "Versant Sud",
  "North Side": "Versant Nord",
  "The Edge": "Le Edge",
  "OPEN": "OUVERTS",
  "Hiking": "Randonnée Pédestre"
}
</i18n>
